module.exports = __webpack_public_path__ + "static/ghubw-39a6a554d6e4c36ee4e307c7ff811c60.png";